import { getPlanPrice, getPlanUnits, isLowestStartingPrice } from '~/modules/helpers/pricingHelper';
import { capitalizeWords } from '~/modules/utilities/pricingUtilities';

export interface ListingDetailCtaContext {
    clickText?: string;
    elementTitle?: string;
    elementType: 'button' | 'link text' | 'tile';
}

// Cardinal Path requires the pricing-card descriptor in English, including on JP sites.
// These are analytics values; displayed labels continue to use the user's locale.
export function getPricingCtaTitle(pricing?: schema.oaf.Pricing): string {
    switch (pricing?.price_model_type) {
        case 'free':
            return 'Free';
        case 'freemium':
            return 'Freemium';
        case 'free_to_install':
            return 'Paid Add-On Required';
        case 'paid': {
            const plan = [...(pricing.model?.plans ?? [])].sort((first, second) => first.index - second.index)[0];
            if (!plan) {
                return 'Paid';
            }
            const price = getPlanPrice(plan.currency_code, plan.price);
            const headline = isLowestStartingPrice(plan) ? `Starting at ${price}` : price;
            const frequencies: Record<string, string> = {
                monthly: 'month',
                yearly: 'year',
                'one-time': 'one-time payment',
            };
            const units = getPlanUnits(plan);
            // Publisher-defined units have no translated counterpart. Use an English
            // category rather than guessing a translation of Japanese free text.
            const analyticsUnits = /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u.test(units)
                ? 'custom unit'
                : units;
            return `${headline}/${capitalizeWords(`${analyticsUnits}/${frequencies[plan.frequency] ?? ''}`)}`;
        }
        default:
            // Match pricingSummaryV2.summaryHeadline when pricing data or its model is absent.
            return 'Free';
    }
}
